import React from 'react';
import { Clock } from 'lucide-react';
import { Button } from './ui/button';

const DEFAULT_TOTAL = 60;

/**
 * Session-continuation warning modal. Non-dismissible (no outside-click / ESC
 * close) — the user must choose "Continue Session" or "Log Out". A progress bar
 * + countdown show the seconds remaining before automatic logout.
 */
export const IdleWarningModal = ({ open, secondsLeft, total = DEFAULT_TOTAL, onContinue, onLogout }) => {
  if (!open) return null;
  const pct = Math.max(0, Math.min(100, (secondsLeft / (total || DEFAULT_TOTAL)) * 100));

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      data-testid="idle-warning-modal"
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 border border-[#E8E5DF]">
        <div className="flex items-center gap-2 mb-3">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#FFE9EE] text-[#FF3B6B]">
            <Clock className="w-5 h-5" />
          </span>
          <h2 className="text-xl font-bold text-[#1E1E24]" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            Still there?
          </h2>
        </div>

        <p className="text-sm text-[#4A4A57] leading-relaxed">
          You've been idle for a while. Would you like to continue your session?
        </p>

        <p className="mt-3 text-sm text-[#6B6B7A]">
          Logging out in{' '}
          <span className="font-bold text-[#FF3B6B]" data-testid="idle-countdown">{secondsLeft}</span>{' '}
          second{secondsLeft === 1 ? '' : 's'}…
        </p>
        <div className="mt-2 h-1.5 w-full rounded-full bg-[#F0EEE9] overflow-hidden">
          <div
            className="h-full bg-[#FF3B6B] transition-[width] duration-1000 ease-linear"
            style={{ width: `${pct}%` }}
            data-testid="idle-countdown-bar"
          />
        </div>

        <div className="mt-5 flex items-center justify-end gap-2">
          <Button
            variant="outline"
            onClick={onLogout}
            className="rounded-full border-[#E8E5DF]"
            data-testid="idle-logout-btn"
          >
            Log Out
          </Button>
          <Button
            onClick={onContinue}
            className="rounded-full bg-[#FF3B6B] hover:bg-[#E62E58] text-white"
            data-testid="idle-continue-btn"
          >
            Continue Session
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IdleWarningModal;
